import { ReactNode } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import { EValidityStatus } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { connectSeasonTicket } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { selectPaymentSum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { TState } from '~/src/store';

interface IProps {
    children: ReactNode,
}

const ConnectButton = ({ children }: IProps): JSX.Element => {
    const dispatch = useDispatch();

    const { wholesaleCheaperData, isPaymentInProcess, bonusesInfo, paySumIsError, paySumIsLoading } = useSelector((state: TState) => ({
        wholesaleCheaperData: state.wholesaleCheaperData.wholesaleCheaperData,
        isPaymentInProcess: state.seasonTicketPayment.isInProcess,
        bonusesInfo: state.seasonTicketPayment.bonusesInfo,
        currentPaySum: selectPaymentSum(state),
        paySumIsError: state.seasonTicketPayment.paySumIsError,
        paySumIsLoading: state.seasonTicketPayment.paySumIsLoading,
    }), shallowEqual);

    const { availableFlags = [] } = wholesaleCheaperData || {};
    const { isUseBonuses, validity } = bonusesInfo;

    const onConnect = () => {
        dispatch(connectSeasonTicket());
    };

    const hasPaySumm = !paySumIsError && !paySumIsLoading;
    const isDisabled = !availableFlags.length || (isUseBonuses ? validity !== EValidityStatus.IS_VALID : false) || !hasPaySumm;

    return (
        <ButtonGroup>
            <Button
                loading={isPaymentInProcess || paySumIsLoading}
                disabled={isDisabled}
                onClick={onConnect}
            >
                {children}
            </Button>
        </ButtonGroup>
    );
};

export default ConnectButton;
